import { useQuery } from '@tanstack/react-query';
import { getSubscriptionPrices } from 'shared/services/backend-api';
import { ID } from 'shared/types/id';

export const queryKey = 'subscription-prices';

// Stripe prices change rarely; an hour bounds how long a stale amount can show
const pricesValidityMs = 60 * 60 * 1000;

// a callable, not a subscription: without refetchOnReconnect a failed fetch stays failed all session
export const subscriptionPricesQueryOptions = {
  retry: 3,
  refetchOnReconnect: true,
  staleTime: pricesValidityMs,
  gcTime: pricesValidityMs,
} as const;

export const useSubscriptionPricesQuery = (uid?: ID) =>
  useQuery({
    queryKey: [queryKey, uid],
    queryFn: async () => getSubscriptionPrices(),
    enabled: !!uid,
    ...subscriptionPricesQueryOptions,
  });
